export default __webpack_public_path__ + "static/qnap-dab77c12ce94eada940acdfbab774e0a.jpg";